export default "__VITE_ASSET__BfNnrlw0__"